import { triggerAutoloader } from '../util/triggerAutoloader';
import { collectCandidateTags } from '../util/collectCandidateTags';
import { removePreventInitAttr } from '../util/removePreventInitAttr';

const uicCollapseHandler = (nodeList: NodeListOf<HTMLElement>) => {
    const handleCollapseChange = ({ detail, currentTarget }: CustomEvent<boolean>) => {
        if (detail && currentTarget) {
            triggerAutoloader(currentTarget as HTMLElement);
            const elements = collectCandidateTags(currentTarget as HTMLElement);
            removePreventInitAttr(elements);
        }
    };

    const init = () => {
        Array.from(nodeList).forEach((node: HTMLElement) => node.addEventListener('onToggle', handleCollapseChange));
    };

    init();
};

export default uicCollapseHandler;
